import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creation: {
    qualificationSteps: [],
    originalData: null,
  },
  update: {
    qualificationSteps: [],
    hasChanges: false,
  },
  display: {
    qualificationSteps: [],
    loading: false,
    error: null,
  },
};

const qualificationStepSlice = createSlice({
  name: "qualificationStep",
  initialState,
  reducers: {
    // Creation actions
    updateCreationQualificationSteps: (state, action) => {
      state.creation.qualificationSteps = action.payload;
    },
    addCreationQualificationStep: (state, action) => {
      state.creation.qualificationSteps.push(action.payload);
    },
    removeCreationQualificationStep: (state, action) => {
      state.creation.qualificationSteps =
        state.creation.qualificationSteps.filter(
          (q) => q.id !== action.payload,
        );
    },
    resetCreation: (state) => {
      state.creation = initialState.creation;
    },
    loadCreationData: (state, action) => {
      state.creation.qualificationSteps = action.payload || [];
    },
    setCreationOriginalData: (state, action) => {
      state.creation.originalData = action.payload;
    },

    // Update actions
    updateUpdateQualificationSteps: (state, action) => {
      state.update.qualificationSteps = action.payload;
      state.update.hasChanges = true;
    },
    addUpdateQualificationStep: (state, action) => {
      state.update.qualificationSteps.push(action.payload);
      state.update.hasChanges = true;
    },
    removeUpdateQualificationStep: (state, action) => {
      state.update.qualificationSteps = state.update.qualificationSteps.filter(
        (q) => q.id !== action.payload,
      );
      state.update.hasChanges = true;
    },
    loadUpdateData: (state, action) => {
      state.update.qualificationSteps = action.payload;
      state.update.hasChanges = false;
    },
    clearUpdateChanges: (state) => {
      state.update.hasChanges = false;
    },
    resetUpdate: (state) => {
      state.update = initialState.update;
    },

    // Display actions
    setDisplayData: (state, action) => {
      state.display.qualificationSteps = action.payload;
      state.display.loading = false;
      state.display.error = null;
    },
    setDisplayLoading: (state, action) => {
      state.display.loading = action.payload;
    },
    setDisplayError: (state, action) => {
      state.display.error = action.payload;
      state.display.loading = false;
    },
    resetDisplay: (state) => {
      state.display = initialState.display;
    },
  },
});

export const {
  updateCreationQualificationSteps,
  addCreationQualificationStep,
  removeCreationQualificationStep,
  loadCreationData,
  setCreationOriginalData,
  updateUpdateQualificationSteps,
  addUpdateQualificationStep,
  removeUpdateQualificationStep,
  loadUpdateData,
  clearUpdateChanges,
  resetCreation,
  resetUpdate,
  setDisplayData,
  setDisplayLoading,
  setDisplayError,
  resetDisplay,
} = qualificationStepSlice.actions;

export default qualificationStepSlice.reducer;
